export const experience = [
    {
        company: 'Controlable.ai',
        role: 'Afstudeerstage (Graduation Intern)',
        period: 'Feb 2026 - Present',
        location: 'Netherlands',
        points: [
            'Building a complete Mesh IoT solution (hardware and software)',
            'Developing sensor devices, custom PCBs, and gateway environments',
            'Creating web environments for data visualization'
        ]
    },
    {
        company: 'Techport',
        role: 'R&D Developer for Edge AI & Smart Maintenance',
        period: 'May 2025 - Jan 2026',
        location: 'IJmuiden, Netherlands',
        points: [
            'Designed and implemented an IoT lab for TinyML applications',
            'Facilitated real-time monitoring and predictive maintenance',
            'Improved system performance and reliability'
        ]
    },
    {
        company: 'DeltaProto',
        role: 'R&D / Full Stack Developer',
        period: 'July 2024 - May 2025 (Intern: Feb 2024 - Aug 2024)',
        location: 'Broek in Waterland',
        points: [
            'Developed full-stack solutions integrating software and hardware',
            'Used Java, React, and Tailwind CSS for modern interfaces'
        ]
    },
    {
        company: 'Protoneering',
        role: 'Freelance Engineer',
        period: '2023 - Present',
        location: 'Netherlands',
        points: [
            'Operating as a freelance alias for personal projects and consulting',
            'Building custom embedded hardware devices'
        ]
    }
];
